var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.closeHandler
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 14 14",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z",
      "fill": "#333333"
    }
  })]), _c('span', [_vm._v("닫기")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }